import React from 'react'
import { Button, Section, Table, RiskBox, Image, Modal } from '../../components'
import { ICONS } from '../../themes'
import { STRING } from '../../helpers'
import NumberFormat from 'react-number-format'
import { supplierManagementBuyerController } from '../../apiService'
import FileDownload from 'js-file-download'
import moment from 'moment'
import { floor } from 'lodash'
export class SupplierDiscoverySection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isModalWarningIsOpen: false,
    }
    // this.updateCreden = props.onClickUpdate.bind(this)
  }

  // componentDidMount() {
  //   this._fetchSustainability()
  // }

  // _fetchSustainability() {
  //   supplierController()
  //     .supplierListSustain()
  //     .then(res => {
  //       this.setState({ supplierListSustain: res })
  //       //console.log('params!!!!!!!!!!!!!!!!!!!!!!!!!', res)
  //     })
  // }

  modal = {
    popupWarningToggle: () => {
      this.setState(prevState => ({
        isModalWarningIsOpen: !prevState.isModalWarningIsOpen,
      }))
    },
  }

  downloadAttachment = params => {
    const funcDownloadFile = async () => {
      try {
        const { name, id } = params
        const fileData = await supplierManagementBuyerController().downloadAttachment(
          id
        )
        const { data } = fileData
        FileDownload(data, name)
      } catch (error) {
        console.log(error)
      }
    }
    funcDownloadFile()
  }

  statusSupplier = status_supplier => {
    switch (status_supplier) {
      case 0:
        return <div className="status not-regis-status">Not Registered</div>
      case 1:
        return <div className="status active-status">Registered</div>
      case 2:
        return <div className="status registration-status">inActive</div>
      case 3:
        return (
          <div className="status wait-active-status">
            Waiting for registration
          </div>
        )
      default:
        return (
          <div className="status wait-active-status">
            Waiting for registration
          </div>
        )
    }
  }

  rendercontactPersons = (contactPersons = []) => {
    if (contactPersons && contactPersons.length > 0) {
      const contactpersonActive = contactPersons.find(
        c => c.contact_person_activate === 1
      )
      if (contactpersonActive) {
        return (
          <div className="data data-contact-person">
            <Table className="table-borderless">
              <Table.TBODY>
                {contactPersons.map((contact, i) => {
                  return (
                    contact.contact_person_activate === 1 && (
                      <Table.TR key={'contact_person_activate' + i}>
                        <Table.TD>
                          <div className="is-ellipsis">
                            {contact.contact_person_full_name}
                          </div>
                        </Table.TD>
                        <Table.TD>
                          <div className="is-ellipsis">
                            <span>Phone: &nbsp; </span>
                            {contact.contact_person_phone}
                          </div>
                        </Table.TD>
                        <Table.TD>
                          <div className="is-ellipsis">
                            <span>Email: &nbsp; </span>
                            {contact.contact_person_mail}
                          </div>
                        </Table.TD>
                      </Table.TR>
                    )
                  )
                })}
              </Table.TBODY>
            </Table>
          </div>
        )
      } else {
        return <div className="data">N/A</div>
      }
    } else {
      return <div className="data">N/A</div>
    }
  }

  render() {
    const supplierInfo = this.props.supplierInfo || {}
    const onlineTemplate = this.props.onlineTemplate || []
    const offlineTemplate = this.props.offlineTemplate || {}
    const regulatory = this.props.regulatory || false
    const credenUpdate = supplierInfo.last_updated_from_creden || ''
    const { isModalWarningIsOpen } = this.state
    // console.log('supplierInfo', supplierInfo)
    let statusCompany = ''
    switch (supplierInfo.status_company) {
      case '1':
        statusCompany = 'ยังดำเนินกิจการอยู่'
        break
      case '2':
        statusCompany = 'พิทักษ์ทรัพย์เด็ดขาด'
        break
      case '3':
        statusCompany = 'แปรสภาพ'
        break
      case '4':
        statusCompany = 'เลิก'
        break
      case '5':
        statusCompany = 'เสร็จการชำระบัญชี'
        break
      case '6':
        statusCompany = 'ควบ'
        break
      case '7':
        statusCompany = 'ถอนหนังสือบริคณห์สนธิ'
        break
      case '8':
        statusCompany = 'ร้าง'
        break
      case '9':
        statusCompany = 'ล้มละลาย'
        break
      case 'A':
        statusCompany = 'ฟื้นฟู'
        break
      case 'B':
        statusCompany = 'คืนสู่ทะเบียน'
        break
      case 'D':
        statusCompany = 'สิ้นสภาพ'
        break
      default:
    }
    return (
      <>
        <Section className="main-content">
          <Section className="content-body">
            <Section className="detail-wrapper">
              <Section className="detail-group-title">
                {STRING.SUPPLIER_INFO}
              </Section>

              <Section className="supplier-discovery-information">
                <Section className="header-info">
                  <Section className="info-wrapper">
                    <Section className="group-with-scoreboard">
                      <Section className="detail-groups">
                        <Section className="detail-group">
                          <div className="label">{STRING.COMPANY_NAME}:</div>

                          <div className="data-control">
                            <div className="data">
                              {supplierInfo.company_name}
                            </div>
                            {supplierInfo.status_account === 2 ? (
                              <Button
                                className="link"
                                onClick={this.modal.popupWarningToggle}
                              >
                                <Image
                                  className="supplier-sign"
                                  src={ICONS['icon-warning-sign.svg']}
                                  alt="warning sign"
                                />
                              </Button>
                            ) : null}
                            {!isNaN(supplierInfo.status_supplier) &&
                              this.statusSupplier(supplierInfo.status_supplier)}

                            {/* <div className="registration-status">
                              Not Registered
                            </div> */}
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">Country:</div>

                          <div className="data-control">
                            {supplierInfo.contact_country &&
                            supplierInfo.contact_country.name
                              ? supplierInfo.contact_country.name
                              : 'N/A'}
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">{STRING.TAX_ID}:</div>

                          <div className="data-control">
                            {supplierInfo.tax_id == '' ? (
                              <div className="data">N/A</div>
                            ) : (
                              <div className="data">{supplierInfo.tax_id}</div>
                            )}
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">{STRING.BRANCH}:</div>

                          {supplierInfo.branch == '' ? (
                            <div className="data">N/A</div>
                          ) : (
                            <div className="data">{supplierInfo.branch}</div>
                          )}
                        </Section>

                        <Section className="detail-group">
                          <div className="label">{STRING.STATUS}:</div>

                          <div className="data-control">
                            {supplierInfo.status_company == '' ||
                            supplierInfo.status_company == '0' ? (
                              <div className="data">N/A</div>
                            ) : (
                              <div className="data">{`${statusCompany}`}</div>
                            )}
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">{STRING.REGIS_ADDRESS}:</div>

                          <div className="data-control">
                            <div className="data">
                              {`${
                                supplierInfo.regis_address &&
                                supplierInfo.regis_address !== ''
                                  ? supplierInfo.regis_address
                                  : 'N/A'
                              }`}
                            </div>
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">{STRING.CONTACT_ADDRESS}:</div>

                          <div className="data-control">
                            <div className="data">
                              {`${supplierInfo.contact_address}`}
                            </div>
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">{STRING.BUSINESS_TYPE}:</div>
                          <div className="data-control">
                            {supplierInfo.business_type &&
                            supplierInfo.business_type.length > 0 ? (
                              <div className="data">
                                {supplierInfo.business_type.map(
                                  (businessType, i) =>
                                    supplierInfo.business_type.length === i + 1
                                      ? businessType.business_type_name
                                      : businessType.business_type_name + ', '
                                )}
                              </div>
                            ) : (
                              <div className="data">N/A</div>
                            )}
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">
                            {STRING.YEAR_ESTABLISHED}:
                          </div>

                          <div className="data-control">
                            <div className="data">
                              {supplierInfo.year_established
                                ? supplierInfo.year_established
                                : 'N/A'}
                            </div>
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">
                            {STRING.REGISTERED_CAPITAL}:
                          </div>

                          <div className="data-control">
                            <div className="data">
                              {supplierInfo.regis_capital > -1 ? (
                                <>
                                  <NumberFormat
                                    value={supplierInfo.regis_capital}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                  />
                                  {` ${supplierInfo.currency.name}`}
                                </>
                              ) : (
                                'N/A'
                              )}
                            </div>
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">
                            {STRING.SERVICE_CATEGORY}:
                          </div>

                          <div className="data-control">
                            <div className="data">
                              {(supplierInfo.service_category || []).map(
                                item => (
                                  <span
                                    key={
                                      'service_category' +
                                      item.category_id +
                                      item.sub_category_id
                                    }
                                  >
                                    <div>
                                      {item.category_name}&nbsp;
                                      {item.sub_category_name !== ''
                                        ? '>'
                                        : null}
                                      &nbsp;
                                      {item.sub_category_name}
                                    </div>
                                  </span>
                                )
                              )}
                            </div>
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">{STRING.PHONE}:</div>

                          <div className="data-control">
                            <div className="data">
                              {supplierInfo.phone && supplierInfo.phone !== ''
                                ? supplierInfo.phone
                                : 'N/A'}
                            </div>
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">{STRING.FAX}:</div>

                          <div className="data-control">
                            <div className="data">
                              {supplierInfo.fax && supplierInfo.fax !== ''
                                ? supplierInfo.fax
                                : 'N/A'}
                            </div>
                          </div>
                        </Section>

                        <Section className="detail-group">
                          <div className="label">{STRING.EMAIL_LABEL}:</div>

                          <div className="data-control">
                            <div className="data">
                              {supplierInfo.email && supplierInfo.email !== ''
                                ? supplierInfo.email
                                : 'N/A'}
                            </div>
                          </div>
                        </Section>
                      </Section>

                      <div className="scoreboard-wrapper">
                        <div className="scoreboard">
                          <div className="risk-level">
                            <div className="caption">Risk Level :</div>
                            <div className="box-status">
                              <div className="status green">Low</div>
                              <div className="status light-green"></div>
                              <div className="status light-orange"></div>
                              <div className="status orange"></div>
                              <div className="status red">High</div>
                            </div>
                          </div>
                          <div className="risk-board">
                            {!this.props.isLoading ||
                            !supplierInfo.financial_info ? (
                              <RiskBox title="Financial" />
                            ) : (
                              <RiskBox
                                value={
                                  parseFloat(supplierInfo.financial) > 0
                                    ? supplierInfo.financial
                                    : ''
                                }
                                title="Financial"
                                score={
                                  parseFloat(supplierInfo.financial) > 0
                                    ? Number(supplierInfo.financial).toFixed(1)
                                    : ''
                                }
                              />
                            )}
                            {supplierInfo.operational == '' ||
                            supplierInfo.operational == null ||
                            !this.props.isLoading ? (
                              <RiskBox title="Operational" />
                            ) : (
                              <RiskBox
                                title="Operational"
                                value={0}
                                score={0}
                                // value={
                                //   supplierInfo.operational <= 1
                                //     ? '1'
                                //     : supplierInfo.operational <= 2
                                //     ? '2'
                                //     : supplierInfo.operational <= 2.4
                                //     ? '3'
                                //     : supplierInfo.operational <= 2.8
                                //     ? '4'
                                //     : '5'
                                // }
                                // score={Number(
                                //   supplierInfo.operational <= 1
                                //     ? '1'
                                //     : supplierInfo.operational <= 2
                                //     ? '2'
                                //     : supplierInfo.operational <= 2.4
                                //     ? '3'
                                //     : supplierInfo.operational <= 2.8
                                //     ? '4'
                                //     : '5'
                                // ).toFixed(1)}
                              />
                            )}

                            {supplierInfo.ss == 0 || !this.props.isLoading ? (
                              <RiskBox title="Sustainability" />
                            ) : (
                              <RiskBox
                                title="Sustainability"
                                value={supplierInfo.ss % 10}
                                score={Number(supplierInfo.ss % 10).toFixed(1)}
                              />
                            )}

                            {!this.props.isLoading ? (
                              <RiskBox title="Regulatory" />
                            ) : regulatory ? (
                              <RiskBox
                                title="Regulatory"
                                value={1}
                                score="1.0"
                              />
                            ) : (
                              <RiskBox
                                title="Regulatory"
                                value={5}
                                score="5.0"
                              />
                            )}
                          </div>
                          {/* <div className="risk-board">
                            <div className="risk-board-row">
                              {!this.props.isLoading ? (
                                <RiskBox title="Financial" />
                              ) : (
                                <RiskBox
                                  value={supplierInfo.financial}
                                  title="Financial"
                                  score={Number(supplierInfo.financial).toFixed(
                                    1
                                  )}
                                />
                              )}
                              {supplierInfo.operational == '' ||
                              supplierInfo.operational == null ||
                              !this.props.isLoading ? (
                                <RiskBox title="Operational" />
                              ) : (
                                <RiskBox
                                  title="Operational"
                                  value={
                                    supplierInfo.operational <= 1
                                      ? '1'
                                      : supplierInfo.operational <= 2
                                      ? '2'
                                      : supplierInfo.operational <= 2.4
                                      ? '3'
                                      : supplierInfo.operational <= 2.8
                                      ? '4'
                                      : '5'
                                  }
                                  score={Number(
                                    supplierInfo.operational <= 1
                                      ? '1'
                                      : supplierInfo.operational <= 2
                                      ? '2'
                                      : supplierInfo.operational <= 2.4
                                      ? '3'
                                      : supplierInfo.operational <= 2.8
                                      ? '4'
                                      : '5'
                                  ).toFixed(1)}
                                />
                              )}
                            </div>
                            <div className="risk-board-row">
                              {supplierInfo.ss == 0 || !this.props.isLoading ? (
                                <RiskBox title="Sustainability" />
                              ) : (
                                <RiskBox
                                  title="Sustainability"
                                  value={supplierInfo.ss % 10}
                                  score={Number(supplierInfo.ss % 10).toFixed(
                                    1
                                  )}
                                />
                              )}
                              {supplierInfo.regulatory == 0 ||
                              !this.props.isLoading ? (
                                <RiskBox title="Regulatory" />
                              ) : (
                                <RiskBox
                                  title="Regulatory"
                                  value={supplierInfo.regulatory}
                                  score={Number(
                                    supplierInfo.regulatory
                                  ).toFixed(1)}
                                />
                              )}
                            </div>
                          </div> */}
                          <hr />
                          <div className="comprehensive-wrapper">
                            <div className="comprehensive-label">
                              Comprehensive
                              <br />
                              Assessment :
                            </div>
                            <div className="comprehensive-status">
                              {onlineTemplate.length > 0 ? (
                                <div className="status green">
                                  <div className="label">Online : Yes</div>
                                </div>
                              ) : (
                                <div className="status gray">
                                  <div className="label">Online : No</div>
                                </div>
                              )}
                              {offlineTemplate.length == '' ? (
                                <div className="status gray">
                                  <div className="label">Offline : No</div>
                                </div>
                              ) : (
                                <div className="status orange">
                                  <div className="label">Offline : Yes</div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Section>
                  </Section>
                </Section>

                <Section className="info-outer-wrapper">
                  <Section className="info-wrapper">
                    <Section className="detail-group">
                      <div className="label">{STRING.WEBSITE}:</div>

                      <div className="data-control">
                        <div className="data">
                          {supplierInfo.website &&
                          supplierInfo.website !== '-' ? (
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={'http://' + supplierInfo.website}
                            >
                              {supplierInfo.website.replace(
                                /^https?\:\/\//i,
                                ''
                              )}
                            </a>
                          ) : supplierInfo.website !== '-' ? (
                            'N/A'
                          ) : (
                            supplierInfo.website
                          )}
                        </div>
                      </div>
                    </Section>

                    {/* --------------------------
                      Attachment: down
                      ----------------------------*/}
                    <Section className="detail-group attachment">
                      <div className="label">{STRING.ATTACHMENT}:</div>

                      <div className="form-group-control">
                        <div className="data">
                          {supplierInfo.attachment &&
                          supplierInfo.attachment.length > 0
                            ? supplierInfo.attachment.map((e, i) => {
                                return (
                                  <React.Fragment key={i}>
                                    <Section className="attached-file-list">
                                      <a
                                        key={i}
                                        href={null}
                                        onClick={() => {
                                          this.downloadAttachment(e)
                                        }}
                                        target="_blank"
                                        className="file-link"
                                        rel="noopener noreferrer"
                                      >
                                        <span className="file-name">
                                          {e.name}
                                        </span>
                                      </a>
                                    </Section>
                                  </React.Fragment>
                                )
                              })
                            : 'N/A'}
                        </div>
                      </div>
                    </Section>

                    {/* --------------------------
                      Contact Person:
                      ----------------------------*/}
                    <Section className="detail-group contact-person">
                      <div className="label">{STRING.CONTACT_PERSON}:</div>
                      <div className="data-control">
                        {this.rendercontactPersons(supplierInfo.contact_person)}
                      </div>
                    </Section>
                  </Section>

                  {/* <Section className="actions">
                    {console.log('MY : ', list)}
                    {console.log('info : ', info)}
                    {
                      // console.log(e)
                      list.find(e => e.my_supplier.tax_id === info.tax_id) ? (
                        <Button
                          disabled={true}
                          className="theme-blue"
                          onClick={() => {
                            console.log(info)
                          }}
                        >
                          Selected
                        </Button>
                      ) : (
                        <Button
                          className="theme-blue"
                          onClick={() => {
                            this.addTolist(info)
                          }}
                        >
                          Select
                        </Button>
                      )
                    }
                    <Button className="theme-blue">
                      Invite to Buyer portal
                    </Button>
                  </Section> */}
                </Section>
              </Section>

              {/* {credenUpdate !== '' && ( */}
              <Section className="updated" mb={'1rem'}>
                {credenUpdate !== '' &&
                  moment(credenUpdate).diff(moment(), 'days') != 0 && (
                    <Button
                      className="link icon-update"
                      onClick={() => {
                        // this.updateCreden()
                        this.props.onClickUpdate(
                          this.props.supplierInfo.supplier_company_id
                        )
                      }}
                    >
                      <Image
                        className=""
                        src={ICONS['icon-update.svg']}
                        alt="update"
                      />
                    </Button>
                  )}
                <Section className="last-update" ml="0.5rem">
                  Last update :{' '}
                  {credenUpdate !== ''
                    ? moment(credenUpdate).format('MMM DD, YYYY')
                    : 'N/A'}
                </Section>
              </Section>
              {/* )} */}
            </Section>
          </Section>
        </Section>

        {/* use same warning popup to pop message */}
        {supplierInfo.status_account === 2 ? (
          <Modal
            id="popup_warning_modal"
            className="popup warning theme-yellow"
            isOpen={isModalWarningIsOpen}
          >
            <Modal.Header>{supplierInfo.company_name}</Modal.Header>

            <Modal.Body>
              <Image src={ICONS['icon-warning.svg']} className="warning" />

              <div className="warning-msg">{supplierInfo.warning}</div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                id="cancel_request_esg_modal"
                className="theme-border-gray close"
                onClick={() => this.modal.popupWarningToggle()}
              >
                {STRING.CLOSE}
              </Button>
            </Modal.Footer>
          </Modal>
        ) : null}
      </>
    )
  }
}
